<!-- begin:: Brand -->
<div class="brand flex-column-auto" [ngClass]="brandClasses" style="background: none" id="kt-aside">
  <!--begin::Logo-->
  <a href="javascript:;" routerLink="/" class="brand-logo">
    <img *ngIf="tenant.features.mindfieldBranding" src="./assets/media/logos/EEGeniusLogo.png" class="max-h-70px" style="height: 45px;" alt="logo">
    <img *ngIf="tenant.current.id === 'feelen'" src="./assets/logos/feelen-logo-transparent.png" class="max-h-70px" style="height: 45px;" alt="logo">
<!--	  <img alt="logo" [attr.src]="headerLogo" class="max-h-70px" style="height: 55px;"/>-->
  </a>
  <!--end::Logo-->

  <ng-container *ngIf="asideSelfMinimizeToggle">
    <!--begin::Toggle-->
    <button class="brand-toggle btn btn-sm px-0" id="kt_aside_toggle" (click)="toggleAsideClick()" tourAnchor="aside-arrow-tour">
      <span class="material-symbols-outlined arrow-icon" [style.transform]="isCollapsedMenu() ? 'rotate(180deg)' : 'rotate(0deg)'" style="color: #fff"> keyboard_double_arrow_left </span>
<!--      <span class="svg-icon svg-icon-xl" [inlineSVG]="'./assets/media/svg/icons/Navigation/Angle-double-left.svg'"></span>-->
    </button>
    <!--end::Toolbar-->
  </ng-container>
</div>
<!-- end:: Brand -->
